import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { PasswordInput } from "../../ui-library/AuthControls/PasswordInput";
import { regex } from "../../../modules/constants";
import { Button } from "../../ui-library/AuthControls/Button";
import Alert from "../../ui-library/Alert/Alert";
import PwChangeSuccessIcon from "../../../assets/svg/pw_change_success.svg";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";

const StyledError = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme?.cardinal};
  text-transform: uppercase;
`;

const PasswordDefine = (props) => {
  const {
    isTokenValid,
    submittedChange,
    passwordToken,
    change,
    setPassword,
    accountUsername,
    setModalTitle,
    showLoginModal,
    goHome,
    token,
    email,
    errorMessage,
    resetErrorMessage,
  } = props;

  const { t } = useTranslation();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);
  const [validConfirmPassword, setValidConfirmPassword] = useState(false);

  const onPasswordChange = (e) => {
    setNewPassword(e.target.value);
    setPassword(e.target.value);
    if (errorMessage) {
      resetErrorMessage();
    }
  };

  const onConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (errorMessage) {
      resetErrorMessage();
    }
  };

  const onDefineSubmit = (event) => {
    event.preventDefault();
    const authToken = passwordToken || token;
    const user = email || accountUsername;
    change(authToken, user);
  };

  const goHomeHandler = (e) => {
    e.preventDefault();
    goHome();
  };

  useEffect(() => {
    if ((newPassword && !regex.test(newPassword)) || !newPassword) {
      setValidPassword(false);
    } else {
      setValidPassword(true);
    }
  }, [newPassword]);

  useEffect(() => {
    if ((confirmPassword && !regex.test(confirmPassword)) || !confirmPassword) {
      setValidConfirmPassword(false);
    } else {
      setValidConfirmPassword(true);
    }
  }, [confirmPassword]);

  useEffect(() => {
    if (submittedChange) {
      setModalTitle(t("contentText.changePasswordConfirmation.title"));
    }
  }, [setModalTitle, submittedChange, t]);

  return !(isTokenValid?.length <= 0) || passwordToken ? (
    isTokenValid !== false ? (
      submittedChange ? (
        <div data-testid="success-modal">
          <Alert
            callback={showLoginModal}
            icon={PwChangeSuccessIcon}
            btnText={t("appText.login")}
            message={
              passwordToken
                ? `${t(
                    "contentText.changePasswordConfirmation.message.success"
                  )} ${t(
                    "contentText.changePasswordConfirmation.message.login"
                  )}`
                : t("contentText.changePasswordConfirmation.message.success")
            }
          />
        </div>
      ) : (
        <form
          onSubmit={onDefineSubmit}
          className="auth-form"
          data-testid="password-define-view"
        >
          <PasswordInput
            placeholder={t("appText.newPassword")}
            onChange={onPasswordChange}
            value={newPassword}
            margin="mb-3"
            field="1"
            autoFocus={true}
          />
          <PasswordInput
            placeholder={t("appText.confirmPassword")}
            onChange={onConfirmPasswordChange}
            value={confirmPassword}
            field="2"
          />
          {newPassword && (
            <StyledError data-testid="validation-error">
              {!validPassword && (
                <span className="invalid-input">
                  {t("errorText.auth.changePassword.validation")}
                </span>
              )}
              {newPassword !== confirmPassword && validPassword && (
                <span>{t("errorText.auth.changePassword.notMatch")}</span>
              )}
            </StyledError>
          )}
          {errorMessage && (
            <StyledError>
              <span>{errorMessage}</span>
            </StyledError>
          )}
          <Button
            text={t("appText.submit")}
            disabled={
              !(
                validPassword &&
                validConfirmPassword &&
                newPassword === confirmPassword
              )
            }
          />
        </form>
      )
    ) : (
      <form onSubmit={goHomeHandler}>
        <p>The link has expired.</p>
        <Button text="Home" />
      </form>
    )
  ) : (
    <LoadingSpinner />
  );
};

export default withTheme(PasswordDefine);
